import React, { useState } from "react";
import { PlannedConsumeCard } from "./PlannedConsumeCard";
import { IngredientEdit, PlannedBase, PlannedEdit } from "./plannedIntakeUtils";
import { DishModification } from "../../data/dishModification";
import { ConfirmModal } from "../ui/ConfirmModal";

export function IntakePlannedSection(props: {
  plannedBase: PlannedBase[];
  edits: Record<string, PlannedEdit>;
  expandedCards: Set<string>;
  loadedDishes?: Record<number, DishModification>;
  hasCustomEdits: boolean;
  onToggleChecked: (sig: string, checked: boolean) => void;
  onToggleExpand: (sig: string) => void;
  onOpenPicker: (sig: string, key: string) => void;
  onApplyEdit: (sig: string, key: string, partial: IngredientEdit) => void;
  onEdit: (sig: string) => void;
  onDelete: (sig: string) => void;
  onReset: () => void;
  onCheckAll: () => void;
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (props.plannedBase.length === 0) return null;

  const handleAllPlanned = () => {
    if (props.hasCustomEdits) {
      setConfirmOpen(true);
      return;
    }
    props.onCheckAll();
  };

  return (
    <div className="flex w-full flex-col gap-2">
      <p className="px-1 text-xs font-semibold uppercase tracking-wider text-ink-muted">
        Geplant ({props.plannedBase.length})
      </p>
      {props.plannedBase.map((base) => {
        const edit = props.edits[base.sig] ?? {
          checked: false,
          ingredients: {},
        };
        return (
          <PlannedConsumeCard
            key={base.sig}
            meal={base.meal}
            personName={base.personName}
            edit={edit}
            dish={
              base.meal.dishId != null && props.loadedDishes
                ? props.loadedDishes[base.meal.dishId]
                : undefined
            }
            onToggleChecked={() =>
              props.onToggleChecked(base.sig, !edit.checked)
            }
            expanded={props.expandedCards.has(base.sig)}
            onToggleExpand={() => props.onToggleExpand(base.sig)}
            onOpenProductPicker={(k) => props.onOpenPicker(base.sig, k)}
            onApplyEdit={(k, partial) =>
              props.onApplyEdit(base.sig, k, partial)
            }
            onEdit={() => props.onEdit(base.sig)}
            onDelete={() => props.onDelete(base.sig)}
          />
        );
      })}
      <button
        type="button"
        data-cy="verzehr-all-planned"
        onClick={handleAllPlanned}
        className="mt-1 rounded-card border border-teal bg-teal/5 px-3 py-2 text-sm font-semibold text-teal"
      >
        Alles wie geplant verzehren
      </button>

      <ConfirmModal
        open={confirmOpen}
        dataCy="verzehr-all-planned-confirm"
        title="Alles wie geplant verzehren?"
        description="Deine manuellen Anpassungen (Mengen und gewählte Produkte) werden verworfen. Der Verzehr wird mit den geplanten Werten übernommen."
        confirmLabel="Ja, wie geplant"
        onCancel={() => setConfirmOpen(false)}
        onConfirm={() => {
          setConfirmOpen(false);
          props.onReset();
          props.onCheckAll();
        }}
      />
    </div>
  );
}
